import ShopChangeRefreshProvider from 'utils/ShopChangeRefreshProvider'
import Locale from 'app/Locale'
import { Switch } from 'react-router-dom'
import PrivateRoutesWrapper from './PrivateRoutesWrapper'

const Main = () => {
  return (
    <ShopChangeRefreshProvider>
      <Locale>
        <Switch>
          <PrivateRoutesWrapper />
        </Switch>
      </Locale>
    </ShopChangeRefreshProvider>
  )
}

export default Main
